import React, { Component } from 'react'
import { connect } from 'react-redux'
import CardVerificationSample from '../samples/CardVerificationSample'
import { makeCardVerification } from '../../../actions/transactionsActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _BASIC_TRANSACTIONS, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus\n($store_id,$api_token,$status,$mpgRequest);"],
    order_ID: ["cardVerification.SetOrderId(order_id);", "cardVerification.setOrderId(order_id);", "'order_id'=>$order_id"],
    credit_card_number: ["cardVerification.SetPan(pan);", "cardVerification.setPan(pan);", "'pan'=>$pan"],
    expiry_date: ["cardVerification.SetExpdate(expiry_date);", "cardVerification.setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    electronic_commerce_indicator: ["cardVerification.SetCryptType(crypt);", "cardVerification.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    AVS_Information: ["cardVerification.SetAvsInfo(avsCheck);", "cardVerification.setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    CVD_Information: ["cardVerification.SetCvdInfo(cvdCheck);", "cardVerification.setCvdInfo(cvdCheck);", "$mpgTxn->setCvdInfo($mpgCvdInfo);"],
    Credential_Info: ["cardVerification.SetCofInfo(cof);", "cardVerification.setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    issuer_ID: ["cof.SetIssuerId(\"VALUE_FOR_ISSUER_ID\");", "cof.setIssuerId(\"VALUE_FOR_ISSUER_ID\");", "$cof->setIssuerId(\"VALUE_FOR_ISSUER_ID\");"],
    payment_indicator: ["cof.SetPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "cof.setPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "$cof->setPaymentIndicator\n(\"PAYMENT_INDICATOR_VALUE\");"],
    payment_information: ["cof.SetPaymentInformation(\"PAYMENT_INFO_VALUE\");", "cof.setPaymentInformation(\"PAYMENT_INFO_VALUE\");", "$cof->setPaymentInformation(\"PAYMENT_INFO_VALUE\");"],
}

export class CardVerification extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakeCardVerification() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _BASIC_TRANSACTIONS, orderId: newOrderId });
        const { storeId, apiToken, orderId, pan, expdate } = this.props;
        const cardVerificationRequest = { storeId, apiToken, orderId, pan, expdate };
        this.props.makeCardVerification(cardVerificationRequest);
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Card Verification</h3>
                <CardVerificationSample />
                <div className="requestButton" onClick={() => this.onMakeCardVerification()}>
                    Card Verification Request
                </div> 
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>{"Card Verification with AVS & CVD"}</b></span>
                <p style={{marginTop: '3vh'}}>Verifies the validity of the credit card, expiry date and any additional details (such as the Card Verification Digits or Address Verification details). It does not verify the available amount or lock any funds on the credit card.</p>

                <div className="thingsToConsider">
                    <h3>Things to Consider: </h3>
                    <ul>
                        <li>The Card Verification transaction is only supported by Visa, Mastercard, Discover and American Express</li>
                        <br />
                        <li>For some Credential on File transactions, Card Verification with AVS and CVD is used as a prior step to get the Issuer ID used in the subsequent transaction</li>
                        <br />
                        <li>{"When testing Card Verification, please use the Visa and MasterCard test card numbers provided in the MasterCard Card Verification and Visa Card Verification tables available in CVD & AVS (E-Fraud) Simulator."}</li>
                        <br />
                        <li>{"For a full list of possible AVS & CVD result codes refer to the CVD and AVS Result Code tables."}</li>
                    </ul>
                </div>

                <p><b>Card Verification transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>CardVerification cardVerification = new CardVerification();</code>
                    case _JAVA:
                        return <code>CardVerification cardVerification = new CardVerification();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’card_verification', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Card Verification transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(cardVerification);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(cardVerification);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Optional connection object field</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Card Verification transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<br /><br />a-Z A-Z 0-9 _ - : . @ spaces</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>credit card number</td>
                        <td><i>String</i><br /><br />max 20-character alphanumeric</td>
                        <td><code>{CODES.credit_card_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>expiry date</td>
                        <td><i>String</i><br /><br />4-character alphanumeric<br />(YYMM format)</td>
                        <td><code>{CODES.expiry_date[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>AVS Information</td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.AVS_Information[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>CVD Informationbr<br /><p className="note"><b>NOTE: </b>When storing credentials on the initial transaction, the CVD object must be sent; for subsequent transactions using stored credentials, CVD can be sent with cardholder-initiated transactions only—merchants must not store CVD information.</p></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.CVD_Information[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>Card Verification transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>Credential on File Info<br />cof<br /><br /><p className="note"><b>NOTE: </b>This is a nested object within the transaction, and required when storing or using the customer's stored credentials. For information about fields in the Credential on FIle Info object, see Credential on File Info Object and Variables.</p></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.Credential_Info[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Credential on File Info object request fields</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>issuer ID<br /><br /><p className="note"><b>NOTE: </b>This variable is required for all merchant-initiated transactions following the first one; upon sending the first transaction, the issuer ID value is received in the transaction response and then used in subsequent transaction requests.</p></td>
                        <td><i>String</i><br /><br />15-character alphanumeric<br />variable length</td>
                        <td><code>{CODES.issuer_ID[progLangId]}</code><br /><br /><p className="note"><b>NOTE: </b>For a list and explanation of the possible values to send for this variable, see Definition of Request Fields – Credential on File</p></td>
                    </tr>
                    <tr>
                        <td>payment indicator<br /><br /><p className="note"><b>NOTE: </b>In Credential on File transactions where the request field e-commerce indicator is also being sent, the acceptable values for ecommerce indicator are dependent on the value sent for payment indicator; see request field definitions for more information.</p></td>
                        <td><i>String</i><br /><br />1-character alphabetic</td>
                        <td><code>{CODES.payment_indicator[progLangId]}</code><br /><br /><p className="note"><b>NOTE: </b>For a list and explanation of the possible values to send for this variable, see Definition of Request Fields – Credential on File</p></td>
                    </tr>
                    <tr>
                        <td>payment information</td>
                        <td><i>String</i><br /><br />1-character alphabetic</td>
                        <td><code>{CODES.payment_information[progLangId]}</code><br /><br /><p className="note"><b>NOTE: </b>For a list and explanation of the possible values to send for this variable, see Definition of Request Fields – Credential on File</p></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, pan, expdate, amount } = state.transactions.main.config;
    return { mode, storeId, apiToken, orderId, pan, expdate, amount, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeCardVerification, updateOrderId})(CardVerification)
